export const GET_FORM_B_REQUEST = "GET_FORM_B_REQUEST";
export const GET_FORM_B_SUCCESS = "GET_FORM_B_SUCCESS";
export const GET_FORM_B_FAILURE = "GET_FORM_B_FAILURE";
